import { render } from "./invitation.vue?vue&type=template&id=3e828041&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"

import "./invitation.vue?vue&type=style&index=0&id=3e828041&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e828041"

export default script